(() => {
  'use strict';
  if (window.__rfShoeSaleFixesLoaded) return;
  window.__rfShoeSaleFixesLoaded = true;

  const pickerSelector = 'variant-picker[data-rf-shoe-sale]';
  const sizeNumber = value => Number.parseFloat(String(value).replace(',', '.'));
  const inputsFor = (picker, position) => Array.from(picker.querySelectorAll('input[type="radio"][data-option-position="' + position + '"]'));

  function labelFor(picker, input) {
    if (input.parentElement?.tagName === 'LABEL') return input.parentElement;
    if (input.nextElementSibling?.tagName === 'LABEL' && input.nextElementSibling.htmlFor === input.id) return input.nextElementSibling;
    return Array.from(picker.querySelectorAll('label')).find(label => label.htmlFor === input.id) || null;
  }

  function optionName(picker, input) {
    const label = labelFor(picker, input);
    return label ? (label.dataset.rfOptionName || label.textContent.trim().replace(/\s+/g, ' ')) : '';
  }

  function availableVariants(picker) {
    const node = picker.querySelector('script[data-rf-sale-variants]');
    if (!node) return [];
    try {
      const variants = JSON.parse(node.textContent);
      return Array.isArray(variants) ? variants.filter(variant => variant.available) : [];
    } catch (error) {
      console.warn('RoyalFeet Shoe Sale: invalid variant data', error);
      return [];
    }
  }

  function sortSizes(picker, sizeInputs) {
    const entries = sizeInputs.map(input => ({ input, label: labelFor(picker, input), size: sizeNumber(optionName(picker, input)) }));
    if (!entries.length || entries.some(entry => !entry.label || !Number.isFinite(entry.size))) return;
    const parent = entries[0].label.parentElement;
    if (!parent || entries.some(entry => entry.label.parentElement !== parent)) return;
    const sorted = [...entries].sort((a, b) => a.size - b.size);
    if (sorted.every((entry, index) => entry.input === entries[index].input)) return;
    const nested = entries.every(entry => entry.input.parentElement === entry.label);
    const adjacent = entries.every(entry => entry.input.parentElement === parent && entry.input.nextElementSibling === entry.label);
    if (!nested && !adjacent) return;
    for (const entry of sorted) {
      if (adjacent) parent.append(entry.input);
      parent.append(entry.label);
    }
  }


  function updateGallery(picker, selectedColor) {
    const root = picker.closest('product-rerender');
    const gallery = root?.querySelector('product-gallery[data-rf-strict-gallery]');
    if (!gallery) return;
    const color = selectedColor.trim().toLowerCase();
    const slides = Array.from(gallery.querySelectorAll('.product-gallery__media[data-rf-color]'));
    const visibleSlides = slides.filter(node => node.dataset.rfColor === color);
    if (!visibleSlides.length) return;
    const filtered = [];
    let firstDot = true;
    let firstThumb = true;
    gallery.querySelectorAll('[data-rf-color]').forEach(node => {
      const visible = node.dataset.rfColor === color;
      node.classList.toggle('rf-color-visible', visible);
      node.hidden = !visible;
      if (node.classList.contains('product-gallery__media') && !visible) {
        filtered.push(Number(node.dataset.rfPosition));
      }
      if (node.matches('page-dots > button')) {
        node.setAttribute('aria-current', visible && firstDot ? 'true' : 'false');
        if (visible) firstDot = false;
      }
      if (node.classList.contains('product-gallery__thumbnail')) {
        node.setAttribute('aria-current', visible && firstThumb ? 'true' : 'false');
        if (visible) firstThumb = false;
      }
    });
    gallery.setAttribute('filtered-indexes', JSON.stringify(filtered));
    gallery.dataset.rfCurrentColor = color;
    const carousel = gallery.querySelector('media-carousel');
    if (carousel && carousel.scrollLeft !== 0) carousel.scrollLeft = 0;
  }

  function refresh(picker, notifyNative = false) {
    if (!picker.isConnected) return;
    const colorInputs = inputsFor(picker, 1);
    const sizeInputs = inputsFor(picker, 2);
    if (!colorInputs.length || !sizeInputs.length) return;
    sortSizes(picker, sizeInputs);
    const variants = availableVariants(picker);
    if (!variants.length) return;
    const selectedColor = colorInputs.find(input => input.checked);
    if (!selectedColor) return;
    const colorName = optionName(picker, selectedColor);
    const sizesInColor = variants.filter(variant => variant.option1 === colorName).map(variant => String(variant.option2));
    if (!sizesInColor.length) return;
    const allowed = new Set(sizesInColor);
    let selectedSize = sizeInputs.find(input => input.checked);
    let corrected = false;
    if (!selectedSize || !allowed.has(optionName(picker, selectedSize))) {
      const firstValid = sizeInputs.filter(input => allowed.has(optionName(picker, input)))
        .sort((a, b) => sizeNumber(optionName(picker, a)) - sizeNumber(optionName(picker, b)))[0];
      if (firstValid) {
        firstValid.disabled = false;
        firstValid.checked = true;
        selectedSize = firstValid;
        corrected = true;
      }
    }
    for (const input of sizeInputs) {
      const valid = allowed.has(optionName(picker, input));
      input.disabled = !valid;
      labelFor(picker, input)?.classList.toggle('is-disabled', !valid);
    }
    updateGallery(picker, colorName);
    if (corrected && notifyNative && selectedSize) {
      selectedSize.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function onSelection(event) {
    if (!(event.target instanceof HTMLInputElement)) return;
    const picker = event.target.closest(pickerSelector);
    if (picker && (event.target.dataset.optionPosition === '1' || event.target.dataset.optionPosition === '2')) {
      refresh(picker, event.target.dataset.optionPosition === '1');
    }
  }

  function initialize() {
    document.querySelectorAll(pickerSelector).forEach(picker => refresh(picker, true));
    const observer = new MutationObserver(records => {
      const affected = new Set();
      for (const record of records) {
        const parent = record.target.nodeType === 1 ? record.target.closest?.(pickerSelector) : null;
        if (parent) affected.add(parent);
        for (const node of record.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches?.(pickerSelector)) affected.add(node);
          node.querySelectorAll?.(pickerSelector).forEach(picker => affected.add(picker));
        }
      }
      affected.forEach(picker => refresh(picker, true));
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('input', onSelection, true);
  document.addEventListener('change', onSelection, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();